define([
  'js/aofl-js/0.8.0/app/app',
  'text!readingiq-src/js/riq-js/aofl-select-list/1.0.0/index.html'
], function aoflSelectListModule(app, html) {
  'use strict';

  app.registerComponent('aoflSelectList', {
    transclude: true,
    require: {
      ngModel: 'ngModel'
    },
    bindings: {
      autofocus: '@?',
      multiple: '@?',
      disabled: '@?',
      form: '@?',
      name: '@?',
      required: '@?',
      size: '@?'
    },
    controller: 'AoflSelectListController',
    template: html
  });

  app.registerController('AoflSelectListController', [
    '$scope',
    function AoflSelectListController($scope) {
      var _this = this;
      var options = [];

      this.setSingleValue = function setSingleValue() {
        var len = options.length;
        var selected = false;
        var val = '';
        if (
          _this.ngModel.$viewValue &&
          (typeof _this.ngModel.$viewValue === 'object'
            ? Object.keys(_this.ngModel.$viewValue).length
            : _this.ngModel.$viewValue.length)
        ) {
          while (len--) {
            if (!selected && _this.ngModel.$viewValue === options[len].value) {
              selected = true;
              val = options[len].value;
              options[len].selected = 'true';
            } else {
              options[len].selected = 'false';
            }
            options[len].updateSelectedAttribute();
          }
        } else {
          while (len--) {
            if (!selected && options[len].selected === 'true') {
              selected = true;
              val = options[len].value;
              options[len].selected = 'true';
              // eslint-disable-next-line
              $scope.$applyAsync(function updateViewValue() {
                _this.ngModel.$setViewValue(val);
              });
            } else {
              options[len].selected = 'false';
            }
            options[len].updateSelectedAttribute();
          }
        }
      };

      this.setSingleSelectedAttribute = function setSingleSelectedAttribute(
        _option
      ) {
        var len = options.length;
        while (len--) {
          options[len].selected = 'false';
          options[len].updateSelectedAttribute();
        }
        _option.selected = 'true';
        this.ngModel.$setViewValue(_option.value);
        _option.updateSelectedAttribute();
      };

      this.setMultipleValue = function setMultipleValue() {
        var selected = [];
        for (var j = 0; j < options.length; j++) {
          if (options[j].selected === 'true') {
            selected.push(options[j].value);
          }
        }
        this.ngModel.$setViewValue(selected);
      };

      this.setMultiSelectedAttribute = function setMultiSelectedAttribute(
        _option
      ) {
        if (_option.selected === 'true') {
          _option.selected = 'false';
        } else {
          _option.selected = 'true';
        }
        _option.updateSelectedAttribute();
      };

      this.addOption = function addOption(_option) {
        options.push(_option);
        this.setValue();
      };

      this.setValue = function setValue() {
        var _this = this;
        $scope.$applyAsync(function ngModelReady() {
          if (_this.multiple === 'true') {
            _this.setMultipleValue();
          } else {
            _this.setSingleValue();
          }
        });
      };

      this.selectionUpdated = function selectionUpdated(_option) {
        if (this.multiple === 'true') {
          this.setMultiSelectedAttribute(_option);
        } else {
          this.setSingleSelectedAttribute(_option);
        }
        this.setValue();
      };

      this.$onInit = function onInit() {
        $scope.$applyAsync(function ngModelReady() {
          _this.ngModel.$render = function render() {
            _this.setValue();
          };
        });
      };
    }
  ]);
});
